import { createHash } from 'crypto';

export const encrypt = (algorithm: 'sha1' | 'md5', content: string) => {
  const hash = createHash(algorithm);
  hash.update(content);
  return hash.digest('hex');
};

export const encryptSha1 = (content: string): string => encrypt('sha1', content);

/**
 * @param {any} content
 *  @return {string}
 */
export const encryptMd5 = (content: string): string => encrypt('md5', content);

export default encrypt;
